import * as React from 'react'

export const SiteLayoutContext = React.createContext<{ collapsed: boolean; toggle: () => void } | undefined>(undefined)

export const useSiteLayoutContext = () => {
    return React.useContext(SiteLayoutContext)
}
